import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import { CityInfoDto, RegionInfoDto } from '@sr/dto';
import TreeComponent from 'components/Mui/tree-countries/tree-checkbox';
import { useState } from 'react';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: any) => Promise<void>;
}

export const MediaChildCreateDialog = ({ open, onClose, onSubmit }: Props) => {
  const [selectedItems, setSelectedItems] = useState<{ regions: number[]; cities: number[] }>({
    regions: [],
    cities: []
  });
  
  const handleTreeDataChange = (data: { regions: number[]; cities: number[] }) => {
    setSelectedItems(data);
  };

  const handleSubmit = async () => {
    try {
      await onSubmit({
        regions: selectedItems.regions,
        cities: selectedItems.cities
      });
      onClose();
    } catch (error) {
      console.error('Ошибка при создании дочерних СМИ:', error);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle>Новые дочерние СМИ</DialogTitle>
      
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <TreeComponent onDataChange={handleTreeDataChange} />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button 
          onClick={handleSubmit}
          variant="contained"
          disabled={selectedItems.regions.length === 0 && selectedItems.cities.length === 0}
        >
          Создать Дочерние СМИ
        </Button>
      </DialogActions>
    </Dialog>
  );
};